import { msg } from '@lit/localize';
/**
 * Represents the button of digital services
 */
export class DinapsisNavbarDigitalServices {
    constructor(url, visibility) {
        this.url = '';
        this.visibility = '';
        this.url = url;
        this.visibility = visibility;
    }
    /**
     * Create the custom component
     * @returns HTML code of the component
     */
    Render() {
        const listelement = document.createElement('div');
        listelement.innerHTML = `<div class="dinapsis-digital-services" style="visibility:${this.visibility === '' || this.visibility === 'hidden' ? 'hidden' : 'inherit'}">
    <a class="link-digital-services" href="${this.url}" target="_blank">${msg('digital_services').toLocaleUpperCase()}</a>
    </div>`;
        return listelement;
    }
}
//# sourceMappingURL=dinapsis-navbar-digital-services.js.map